export const ReducerKeys = Object.freeze({
  FLEX_REWARD_COACHMARK_URLS: 'flexRewardCoachmarkUrls',
  HAS_ACTIVE_PREMIUM_ACCESS: 'hasActivePremiumAccess',
  OPEN_COACHMARK: 'openCoachmark',
  PLAYABLE_SOURCE_ID: 'playableSourceId',
  PREMIUM_ACCESS: 'premium_access', // must be snakeCase because this is what we get from the server
  REPLAYABLE_TRACKS: 'replayableTracks',
  REPLAYABLE_TRACKS_LIMIT: 'replayableTracksLimit',
  REPLAYS: 'replays',
  REWARDS: 'rewards',
  SKIPS: 'skips',
  TRACKING_EVENTS: 'trackingEvents',
  WAS_PLAYING_WHEN_STARTED: 'wasPlayingWhenStarted',
} as const);

export const RewardsTypes = [
  ReducerKeys.SKIPS,
  ReducerKeys.REPLAYS,
  ReducerKeys.PREMIUM_ACCESS,
] as const;

export const CoachmarkConstants = Object.freeze({
  COACHMARK_CONTAINER: 'region-coachmark',
  PA_CAP_COACHMARK: 'PA_CAP',
  PREMIUM_ACCESS_COACHMARK: 'premiumAccess',
  PREMIUM_ACCESS_COACHMARK_TYPE: 'slopa',
  REPLAY_COACHMARK: 'replay',
  SKIP_COACHMARK: 'skip',
  STATIC_AD_TARGETING_MACRO: '__STATIC_AD_TARGETING__',
  THUMBS_DOWN_COACHMARK: 'thumbsDown',
} as const);

export const CoachmarkErrors = Object.freeze({
  AD_URL_UNAVAILABLE: 'COACHMARK_URL_UNAVAILABLE',
  RESPONSE_PAYLOAD_EMPTY: 'RESPONSE_PAYLOAD_EMPTY',
  NO_RESPONSE_FROM_SERVER: 'NO_RESPONSE_FROM_SERVER',
} as const);

export const AutoCloseCoachmarkConstants = [
  CoachmarkConstants.THUMBS_DOWN_COACHMARK,
  CoachmarkConstants.SKIP_COACHMARK,
  CoachmarkConstants.REPLAY_COACHMARK,
] as const;

export const CoachmarkUrlKeys = Object.freeze({
  [CoachmarkConstants.SKIP_COACHMARK]: 'flexSkipAdUrl',
  [CoachmarkConstants.THUMBS_DOWN_COACHMARK]: 'flexThumbsDownAdUrl',
  [CoachmarkConstants.REPLAY_COACHMARK]: 'flexReplayAdUrl',
  PREMIUM_ACCESS_AD_URL: 'premiumAccessAdUrl',
  PREMIUM_ACCESS_NO_AVAILS_AD_URL: 'premiumAccessNoAvailsAdUrl',
} as const);

export const ActionKeys = Object.freeze({
  CLEAR_OPEN_COACHMARK: 'CLEAR_OPEN_COACHMARK',
  CLEAR_REWARDS_ON_PA_SESSION: 'CLEAR_REWARDS_ON_PA_SESSION',
  EXPIRE_VALUE_EXCHANGE_REWARD: 'EXPIRE_VALUE_EXCHANGE_REWARD',
  INIT_REWARDS_DOMAIN: 'INIT_REWARDS_DOMAIN',
  OPEN_PREMIUM_ACCESS_COACHMARK: 'OPEN_PREMIUM_ACCESS_COACHMARK',
  SAVE_PLAYABLE_SOURCE_ID: 'SAVE_PLAYABLE_SOURCE_ID',
  SET_HAS_ACTIVE_PREMIUM_ACCESS: 'SET_HAS_ACTIVE_PREMIUM_ACCESS',
  SET_TRACK_REPLAYABLE_LIMIT: 'SET_TRACK_REPLAYABLE_LIMIT',
  SET_TRACK_TO_REPLAY: 'SET_TRACK_TO_REPLAY',
  START_VALUE_EXCHANGE_SUCCESS: 'START_VALUE_EXCHANGE_SUCCESS',
  USE_REPLAY_REWARD_AFTER_CREATION: 'USE_REPLAY_REWARD_AFTER_CREATION',
  USE_SKIP_REWARD_AFTER_CREATION: 'USE_SKIP_REWARD_AFTER_CREATION',
  WAS_PLAYING_WHEN_STARTED: 'WAS_PLAYING_WHEN_STARTED',
} as const);

export const RewardsConstants = Object.freeze({
  // @TODO: temporary until we get runtime config from server
  BACKGROUNDING_TIMEOUT_MILLISECONDS: 90000,
  PREMIUM_ACCESS_TYPE_FOR_DISPLAY: 'music',
  PREMIUM_ACCESS_WELCOME_MESSAGE_LIMIT: 1,
  REPLAYS_BUNDLE_SIZE: 3,
  REPLAYS_TIMEOUT: 24 * 60 * 60 * 1000, // 24 hrs
  SKIPS_BUNDLE_SIZE: 3,
  SKIPS_TIMEOUT: 24 * 60 * 60 * 1000, // 24 hrs
} as const);

export const RewardsActions = Object.freeze({
  GLOBAL_START_VALUE_EXCHANGE: 'GLOBAL_START_VALUE_EXCHANGE',
  GLOBAL_CLOSE_REWARDS_COACHMARK: 'GLOBAL_CLOSE_REWARDS_COACHMARK',
} as const);

export const RewardsErrors = Object.freeze({
  GENERAL_REWARDS_ERROR: 'GENERAL_REWARDS_ERROR',
  INSUFFICIENT_REWARD_REPLAYS: 'INSUFFICIENT_REWARD_REPLAYS',
  INSUFFICIENT_REWARD_SKIPS: 'INSUFFICIENT_REWARD_SKIPS',
} as const);

// For analytics
export const FlexRewardContextValues = Object.freeze({
  T1_REPLAY_NO_REWARD: 'T1_replay_no_reward',
  T1_REPLAY_YES_REWARD: 'T1_replay_yes_reward',
  T1_SKIPS_AT_LIMIT_NO_REWARD: 'T1_skips_at_limit_no_reward',
  T1_SKIPS_AT_LIMIT_YES_REWARD: 'T1_skips_at_limit_yes_reward',
  T1_SKIPS_NOT_AT_LIMIT_NO_REWARD: 'T1_skips_not_at_limit_no_reward',
  T1_SKIPS_NOT_AT_LIMIT_YES_REWARD: 'T1_skips_not_at_limit_yes_reward',
  T2_UNLIMITED: 'T2_unlimited',
  T3_UNLIMITED: 'T3_unlimited',
} as const);

export const VideoBackgroundingAudioSettings = Object.freeze({
  [ReducerKeys.SKIPS]: {
    url: 'https://www.pandora.com/static/creatives/valueExchange/Flex/Audio/Skips_V1_JRutkowski_Pandora_ProductMgmt_IACS-1096.mp3',
    duration: 3000,
  },
  [ReducerKeys.REPLAYS]: {
    url: 'https://www.pandora.com//static/creatives/valueExchange/Flex/Audio/Replays_V1_JRutkowski_Pandora_ProductMgmt_IACS-1096.mp3',
    duration: 3000,
  },
  [ReducerKeys.PREMIUM_ACCESS]: {
    url: 'http://pandora.com/static/creatives/valueExchange/slopa/audio/SLOPA-Background_V2.mp3',
    duration: 3000,
  },
} as const);
